/**
 * @desc 保存msku映射
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.omsFlow.SellerSkuToMapRpcDto>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/msku/saveAmazonSellerSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
